import { Component, OnInit , Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { AddPopupComponent } from 'app/organization/Popups/add-popup/add-popup.component';
import {NgForm, FormBuilder, FormGroup, FormControl} from '@angular/forms';

@Component({
  selector: 'app-add-job-position',
  templateUrl: './add-job-position.component.html',
  styleUrls: ['./add-job-position.component.css']
})
export class AddJobPositionComponent implements OnInit  {
  public positionName: string;
  public reportingTo: string;
  public organogram = [];
  public mode: string;
  public index;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<AddPopupComponent>) { }

  ngOnInit() {
    if (this.data != null ) {
      this.organogram = this.data.organogram;
      this.mode = this.data.mode;
      this.index = this.data.i;
      if (this.mode === 'Edit') {
      this.positionName = this.organogram[this.index].position;
      this.reportingTo = this.organogram[this.index].reportingTo;
      } else {
        this.positionName = '';
        this.reportingTo = ''
      }
    }
  }
  cancel() {
    this.dialogRef.close('Cancel');
  }
  addPosition() {
    this.dialogRef.close({'position': this.positionName, 'reportingTo': this.reportingTo});
    this.organogram = [];
  }
}
